module.exports = __webpack_public_path__ + "static/media/pagi-prev-page.20a9d952.svg";